import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});
const styles = StyleSheet.create({
  page: {
    padding: 20
  },

  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  boldText: {
    fontFamily: 'Roboto',
    fontWeight: 'ultrabold'
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 9,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '12%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'start'
  },
  columnContent: {
    width: '12%',
    padding: 3,
    textAlign: 'start',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};
const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const UserWiseCollectionSummaryPdf = ({ data }) => {

  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }
  const calculateTotalByUser = (data) => {
    const totalByUser = {}
    const sumUserStats = (userStats) => {
      Object.keys(userStats).forEach((userKey) => {
        const user = userStats[userKey];
        if (!totalByUser[userKey]) {
          totalByUser[userKey] = { CASH: 0, BANK: 0, CREDIT: 0, REFUND: 0,RECEIPT:0 };
        }
        totalByUser[userKey].CASH += user.recd_amt_cash || 0;
        totalByUser[userKey].BANK += user.recd_amt_bank || 0;
        totalByUser[userKey].CREDIT += user.recd_amt_credit || 0;
        totalByUser[userKey].REFUND += user.recieved_amt || 0; 
        totalByUser[userKey].RECEIPT += user.recd_amt || 0; 
      });
    };
    const dataSources = ['opdData', 'opdBillingData', 'indoorServiceData', 'paymentRefundData','receiptVoucherData'
    ];
    dataSources.forEach((dataSource) => {
      if (data[dataSource] && data[dataSource].userStats) {
        sumUserStats(data[dataSource].userStats);
      }
    });
    return totalByUser;
  };
  const totalByUser = calculateTotalByUser(data);
  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Collection Summary Report ">
          <Page style={styles.page} size="A4" orientation="landscape">
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />
            <Text
              style={{ ...styles.boldText, textAlign: 'center', fontSize: '10px' }}
              content="USER WISE COLLECTION SUMMARY"
            />
            <View style={styles.row}>
              <Text style={styles.columnHeader} content="Sr No." />
              <Text style={styles.columnHeader} content=" Bill Date" />
              <Text style={styles.columnHeader} content="Opd Type" />
              <Text style={{ ...styles.columnHeader, width: '25%' }} content="Patient Name" />
              <Text style={styles.columnHeader} content="Paymode" />
              <Text style={{ ...styles.columnHeader, width: '25%', textAlign: 'center' }} content="Consultant" />
              <Text style={{ ...styles.columnHeader, width: '25%', textAlign: 'center' }} content="Services" />
              <Text style={styles.columnHeader} content="Panel" />
              <Text style={styles.columnHeader} content="Bill Amt." />
              <Text style={styles.columnHeader} content="Dis Amt." />
              <Text style={styles.columnHeader} content="Recd Amt." />
              <Text style={styles.columnHeader} content="Bal. Amt." />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD " />
            </View>
            {data &&
              data?.opdData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={styles.columnContent} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content={data?.opdtypeData?.type} />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={`${data.name_suffix} ${data.first_name} ${data.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={data.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content="Consultancy" />
                  <Text style={styles.columnContent} content={data.sponsor.name} />
                  <Text style={styles.columnContent} content={data.reg} />
                  <Text style={styles.columnContent} content={data.disc} />
                  <Text style={styles.columnContent} content={data.recd} />
                  <Text style={styles.columnContent} content={data.bal} />
                </View>
              ))}
            <View style={{ marginLeft: '66%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{ fontSize: '9px', width: '21%', fontFamily: 'Roboto', color: 'red' }}
                content="OPD TOTAL : "
              />
              <Text
                style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto', margin: 1 }}
                content={Math.round(data?.opdData?.stats?.bill_amt)}
              />
              <Text
                style={{ ...styles.columnContent, width: '16%', fontFamily: 'Roboto', margin: 1 }}
                content={data?.opdData?.stats?.disc_amt}
              />
              <Text
                style={{ ...styles.columnContent, width: '21%', fontFamily: 'Roboto', margin: 1 }}
                content={Math.round(data?.opdData?.stats?.recd_amt)}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', margin: 1 }}
                content={data?.opdData?.stats?.bal_amt}
              />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="OPD Billing" />
            </View>
            {data &&
              data?.opdBillingData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={styles.columnContent} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="OPD Billing" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={data.patient.consultant.name} />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={data.combinedServiceDetails
                      .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')}
                  />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={styles.columnContent} content={data.total_amt} />
                  <Text style={styles.columnContent} content={data.disc_amt} />
                  <Text style={styles.columnContent} content={data.total_recd} />
                  <Text style={styles.columnContent} content={data.balance_amt} />
                </View>
              ))}

            <View style={{ marginLeft: '63%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{ fontSize: '9px', width: '26%', fontFamily: 'Roboto', color: 'red' }}
                content="OPD Billing Total : "
              />
              <Text
                style={{ ...styles.columnContent, width: '19%', fontFamily: 'Roboto', margin: 1 }}
                content={data?.opdBillingData?.stats?.bill_amt}
              />
              <Text
                style={{ ...styles.columnContent, width: '15%', fontFamily: 'Roboto', margin: 1 }}
                content={data?.opdBillingData?.stats?.disc_amt}
              />
              <Text
                style={{ ...styles.columnContent, width: '21%', fontFamily: 'Roboto', margin: 1 }}
                content={data?.opdBillingData?.stats?.recd_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', margin: 1 }}
                content={data?.opdBillingData?.stats?.bal_amt}
              />
            </View>
            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="Receipt Voucher" />
            </View>
            {data &&
              data?.receiptVoucherData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={styles.columnContent} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="Receipt Voucher" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={''} />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={styles.columnContent} content={0} />
                  <Text style={styles.columnContent} content={0} />
                  <Text style={styles.columnContent} content={data.received_amount} />
                  <Text style={styles.columnContent} content={0} />
                </View>
              ))}
            <View style={{ marginLeft: '61%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{ fontSize: '9px', width: '33%', fontFamily: 'Roboto', color: 'red' }}
                content="Reciept Voucher TOTAL : "
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', width: '17%' }}
                content={data?.receiptVoucherData?.stats?.bill_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', width: '16%' }}
                content={data?.receiptVoucherData?.stats?.disc_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', width: '17%' }}
                content={data?.receiptVoucherData?.stats?.recd_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto' }}
                content={data?.receiptVoucherData?.stats?.bal_amt}
              />
            </View>

            <View style={{ ...styles.row, marginTop: '2%' }}>
              <Text style={{ fontSize: '10px' }} content="Payment Refund Voucher " />
            </View>
            {data &&
              data?.paymentRefundData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={styles.columnContent} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="Payment Refund" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.payment_mode} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={data.patient.consultant.name} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={''} />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={styles.columnContent} content={0} />
                  <Text style={styles.columnContent} content={0} />
                  <Text style={styles.columnContent} content={data.amount} />
                  <Text style={styles.columnContent} content={0} />
                </View>
              ))}

            <View style={styles.row}>
              <Text style={{ fontSize: '10px' }} content="IPD Billing" />
            </View>
            {data &&
              data?.indoorServiceData?.data?.map((data, index) => (
                <View key={index} style={{ ...styles.row, backgroundColor: COLORS[index % COLORS.length] }}>
                  <Text style={styles.columnContent} content={index + 1} />
                  <Text style={styles.columnContent} content={formatDate(data?.date)} />
                  <Text style={styles.columnContent} content="IPD Billing" />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={`${data.patient.name_suffix} ${data.patient.first_name} ${data.patient.last_name}`}
                  />
                  <Text style={styles.columnContent} content={data.pay_mode} />
                  <Text style={{ ...styles.columnContent, width: '25%' }} content={data.patient.consultant.name} />
                  <Text
                    style={{ ...styles.columnContent, width: '25%' }}
                    content={data.combinedServiceDetails
                      .map(({ service_name, test_name }) => service_name || test_name)
                      .join(', ')}
                  />
                  <Text style={styles.columnContent} content={data.patient.sponsor.name} />
                  <Text style={styles.columnContent} content={data.total_amt} />
                  <Text style={styles.columnContent} content={data.disc_amt} />
                  <Text style={styles.columnContent} content={data.total_recd} />
                  <Text style={styles.columnContent} content={data.balance_amt} />
                </View>
              ))}
            <View style={{ marginLeft: '64%', marginTop: '7px', flexDirection: 'row', marginBottom: 0 }}>
              <Text
                style={{ fontSize: '9px', width: '26%', fontFamily: 'Roboto', color: 'red' }}
                content="IPD Billing TOTAL : "
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', width: '20%' }}
                content={data?.indoorServiceData?.stats?.bill_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', width: '18%' }}
                content={data?.indoorServiceData?.stats?.disc_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto', width: '18%' }}
                content={data?.indoorServiceData?.stats?.recd_amt}
              />
              <Text
                style={{ ...styles.columnContent, fontFamily: 'Roboto' }}
                content={data?.indoorServiceData?.stats?.bal_amt}
              />
            </View>
            <View style={{ ...styles.row, width: '100%', marginTop: '30px' }}>
    <Text style={{ ...styles.columnHeader, width: '20%', fontFamily: 'Roboto' }} content="Username" />
    <Text style={{ ...styles.columnHeader, width: '20%', fontFamily: 'Roboto' }} content="Cash" />
    <Text style={{ ...styles.columnHeader, width: '20%', fontFamily: 'Roboto' }} content="Bank" />
    <Text style={{ ...styles.columnHeader, width: '20%', fontFamily: 'Roboto' }} content="Credit" />
    <Text style={{ ...styles.columnHeader, width: '20%', fontFamily: 'Roboto' }} content="Receipt" />
    <Text style={{ ...styles.columnHeader, width: '20%', fontFamily: 'Roboto' }} content="Refund" />
  </View>
{Object.keys(totalByUser).map((userKey) => {
  const user = totalByUser[userKey];
  return (
    <View style={{ ...styles.row }} key={userKey}>
      <Text style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto' }} content={userKey} />
      <Text style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto' }} content={user.CASH} />
      <Text style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto' }} content={user.BANK} />
      <Text style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto' }} content={user.CREDIT} />
      <Text
        style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto' }}
        content={user.RECEIPT || 0}
      />
      <Text
        style={{ ...styles.columnContent, width: '20%', fontFamily: 'Roboto' }}
        content={user.REFUND || 0}
      />
    </View>
  );
})}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default UserWiseCollectionSummaryPdf;
